import { Component, Input } from '@angular/core';
import { HelpTicket } from '@shared/models/help-ticket.model';

@Component({
  selector: 'miq-ticket-detail-attachments',
  templateUrl: './ticket-detail-attachments.component.html',
  styleUrls: ['./ticket-detail-attachments.component.scss'],
  standalone: false,
})
export class TicketDetailAttachmentsComponent {
  @Input() public ticketDetail: HelpTicket;
}
